// store.js
import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import { combineReducers } from "redux";

import user from "./reducers/user";
import sidebarReducer from "./reducers/sidebar";
import modules from "./reducers/data/modules";
import home from "./reducers/data/home";
import zbut from "./reducers/data/zbut";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  // Дневният статус по "ЗБУТ" се пита от сървъра при всяко зареждане.
  blacklist: ["zbut"],
};

const rootReducer = combineReducers({
  user,
  sidebarReducer,
  modules,
  home,
  zbut,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
        ignoredPaths: ['register'],
      },
    }),
});

export default store;
